import React from 'react';
import { useDarkMode } from '../../context/DarkModeContext';
import { useRoleTheme } from '../../hooks/useRoleTheme';
interface TagListProps {
  items: string[];
  type: 'trope' | 'warning';
}
export const TagList: React.FC<TagListProps> = ({
  items,
  type
}) => {
  const {
    darkMode
  } = useDarkMode();
  const rt = useRoleTheme();
  const colorClass = type === 'trope' ? darkMode ? 'bg-blue-900/40 text-blue-300' : 'bg-blue-100 text-blue-800' : darkMode ? 'bg-amber-900/40 text-amber-300' : 'bg-amber-100 text-amber-800';
  return <div className="flex flex-wrap gap-2 mt-2" data-id="element-7722" data-mp="9j8zupr22x96">
      {items.map((item, index) => <span key={index} className={`px-2 py-1 ${rt.badgeRadius} text-xs font-medium ${colorClass}`} data-id="element-7723" data-mp="9gw85kvhx8ix" data-mpi={index}>
          {item}
        </span>)}
    </div>;
};